"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var multi_clamp_1 = tslib_1.__importDefault(require("multi-clamp"));
var React = tslib_1.__importStar(require("react"));
var recompose_1 = require("recompose");
var styled_components_1 = require("styled-components");
var StyledText_1 = require("./StyledText");
var TextInner = /** @class */ (function (_super) {
    tslib_1.__extends(TextInner, _super);
    function TextInner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ref = React.createRef();
        return _this;
    }
    TextInner.prototype.componentDidMount = function () {
        var clampLines = this.props.clampLines;
        if (!!clampLines && clampLines > 0) {
            // tslint:disable-next-line: no-unused-expression
            new multi_clamp_1.default(this.ref.current, {
                ellipsis: '...',
                clamp: clampLines
            });
        }
    };
    TextInner.prototype.render = function () {
        var _a = this.props, color = _a.color, size = _a.size, font = _a.font, tag = _a.tag, clampLines = _a.clampLines, rest = tslib_1.__rest(_a, ["color", "size", "font", "tag", "clampLines"]);
        return React.createElement(StyledText_1.StyledText, tslib_1.__assign({ as: tag || 'span', ref: this.ref, colorProp: color, size: size, font: font }, rest));
    };
    TextInner.defaultProps = {
        tag: 'span',
        color: 'text'
    };
    return TextInner;
}(React.Component));
/** @component */
exports.Text = recompose_1.compose(styled_components_1.withTheme)(TextInner);
//# sourceMappingURL=Text.js.map